/* global PublicKeyCredential */

import logoImage from "../../image_1752851320826.png";

function Splash() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white dark:bg-gray-900">
      <div className="text-center">
        <img
          src={logoImage}
          alt="Logo"
          className="w-24 h-24 mx-auto mb-4 rounded-md animate-pulse"
        />
        <h1 className="text-xl font-semibold text-gray-700 dark:text-white">
          Loading...
        </h1>
      </div>
    </div>
  );
}
export default Splash;
